import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

const PasswordVisibilityToggle = ({ isVisible, onToggle, className = '' }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`absolute right-3 top-1/2 -translate-y-1/2 text-accent-500 hover:text-accent-700 focus:outline-none focus:text-accent-700 transition-colors ${className}`}
      aria-label={isVisible ? 'Hide password' : 'Show password'}
    >
      {isVisible ? <EyeOff size={20} /> : <Eye size={20} />}
    </button>
  );
};

export default PasswordVisibilityToggle;